
$.message = function (text, type) {
    if (text === undefined || text === null || text === '') {
        text = 'An error occured. Could be network related. Please check your network connection.'
    }

    if (type == "error") {
        noty({ text: '<i class="glyphicon glyphicon-warning-sign"></i> ' + text + '<br/><br/>', type: type, timeout: 2000, layout: 'bottom' });
    } else {
        noty({ text: '<i class="glyphicon glyphicon-ok"></i> ' + text, type: type, timeout: 2000, layout: 'bottom' });
    }
};

var MessageText = {
    GameSuccessfullySaved: 'Game saved successfully.',
    GameSuccessfullyUpdated: 'Game updated successfully.',
    GameSuccessfullyDeleted: 'Game is now deleted.',
    GameSuccessfullyCancelled: 'Game is now cancelled.',
    GameSuccessfullyVoided: 'Game is void.',
    GameSuccessfullyPublished: 'Game is published.',
    GameSuccessfullyUnCancelled: 'Game is now un-cancelled.',
    GameSuccessfullyCreated: 'Game created successfully.',

    EventSuccessfullySaved: 'Event saved successfully.',
    EventSuccessfullyUpdated: 'Event updated successfully.',
    EventSuccessfullyDeleted: 'Event is now deleted.',
    EventSuccessfullyReleased: 'Event is released.',
    EventSuccessfullyActivated: 'Event is active.',
    EventSuccessfullyCancelled: 'Event is cancelled.',
    EventSuccessfullyStarted: 'Event is started.',
    EventSuccessfullyEnded: 'Event has ended.',
    EventSuccessfullyVoided: 'Event is void.',
    EventSuccessfullySuspended: 'Event suspended.',
    EventSuccessfullyChangePending: 'Event change pending.',

    ResultSuccessfullySaved: 'Result saved successfully.',
    ResultSuccessfullyPublished: 'Result Published successfully.',

    EventExtraInfoSuccessfullySaved: "Event Info saved successfully.",
    EventPreDrawCertificateSaved: "Pre-Draw Certificate saved successfully.",

    SettingSuccessfullySaved: 'Setting saved successfully.',
    SettingSuccessfullyUpdated: 'Setting updated successfully.',

    SportCodeSuccessfullySaved: 'Sport Code saved successfully.',
    SportCodeSuccessfullyDeleted: 'Sport Code deleted successfully.'
};

var MessageType = {
    Success: "success",
    Error: "error",
    Info: "information",
    Warning: "warning"
};

$.IsStepByStepOn = function() {
    var authenticationData = JSON.parse(localStorage.getItem("authenticationData"));
    var sportCode = localStorage.getItem("sportCode");

    if (authenticationData === null || authenticationData === undefined) return false;
    if (sportCode === null || sportCode === undefined) return false;

    if (sportCode === "IL") return false;
    if (authenticationData.steps === true) return true;

    else return false;
}; 
